class CheckEnvServiceClass {
  areWeInDevEnvironment() {
    try {
      return (
        window.SS_GLOBALS.environment === 'dev' ||
        window.SS_GLOBALS.frontEndConfig.serverEnv === 'SS-Z' ||
        window.SS_GLOBALS.internalTestServer
      );
    } catch {
      return false;
    }
  }

  areWeInDynamicDevEnvironment() {
    try {
      return window.SS_GLOBALS.internalTestServer;
    } catch {
      return false;
    }
  }

  areWeInProdEnvironment() {
    try {
      return window.SS_GLOBALS.environment === 'prod' && !window.SS_GLOBALS.internalTestServer;
    } catch {
      return false;
    }
  }

  getEnvironmentStringFromDDEStatus() {
    if (window.SS_GLOBALS.frontEndConfig.serverEnv === 'LOCAL') {
      return 'local';
    }
    return this.areWeInDynamicDevEnvironment() ? 'development' : 'production'; // need better way of differentiating stage, intg, local, dde, etc
  }
}

export const CheckEnvService = new CheckEnvServiceClass();
